import api from "../../../services/api";

export type AOVMonthEntry = {
  period: string;
  value: number;
};

export type AOVResponse = {
  aov_per_month: AOVMonthEntry[];
  aov_yoy: {
    current_aov: number;
    yoy_change_percent: number;
  };
  highest_aov: {
    year: number;
    month: string;
    value: number;
  };
  avg_of_all_avg_last_year: number;
};

export const getWholesaleAverageOrderValue = async () => {
  const response = await api.get<{ average_order_value: AOVResponse }>(
    "/api/wholesale/customer_insights/average_order_value"
  );
  return response.data.average_order_value;
};
